import { render, staticRenderFns } from "./permission-combox.vue?vue&type=template&id=c447f6d4&scoped=true"
import script from "./permission-combox.vue?vue&type=script&lang=js"
export * from "./permission-combox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c447f6d4",
  null
  
)

export default component.exports